import {
    FETCH_FLOORS_DATA,
    FETCH_FLOORS_DATA_FETCHING,
    FETCH_FLOORS_DATA_FAIL,
    FETCH_FLOORS_DATA_SUCCESS
} from '../../actions/ActionTypes';

const initialState = {
    floorsData: {},
    floorsDataFetching: false,
    floorsDataFetchFail: false
};

//handlers
function fetchFloorsDataSuccess(state, action) {
    return {
        floorsData: {
            ...state.floorsData,
            [action.displayName]: {
                ...state.floorsData[action.displayName],
                [action.calendarDate]: action.data
            }
        },
        floorsDataFetching: false,
        floorsDataFetchFail: false
    };
}

function setFetchingFloorsData(state, action) {
    return {
        ...state,
        floorsDataFetching: true
    };
}

function fetchFloorsDataFailHandler(state, action) {
    return {
        floorsData: {
            ...state.floorsData,
            [action.displayName]: {
                ...state.floorsData[action.displayName],
                [action.calendarDate]: []
            }
        },
        floorsDataFetchFail: true,
        floorsDataFetching: false
    };
}

const handlers = {
    [FETCH_FLOORS_DATA_SUCCESS]: fetchFloorsDataSuccess,
    [FETCH_FLOORS_DATA_FAIL]: fetchFloorsDataFailHandler,
    [FETCH_FLOORS_DATA_FETCHING]: setFetchingFloorsData
};

export default function floorsData(state = initialState, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// action
export function fetchDailyFloorsData(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_FLOORS_DATA,
        calendarDate: calendarDate,
        displayName: displayName,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// get functions
export function fetchFloorsDataFail(state) {
    return state.floorsData.floorsDataFetchFail;
}

export function floorsDataFetching(state) {
    return state.floorsData.floorsDataFetching;
}

export function getFloorsAllData(state) {
    return state.floorsData.floorsData;
}

export function getFloorsDataByNameAndDate(state, displayName, calendarDate) {
    return state.floorsData.floorsData[displayName] ? state.floorsData.floorsData[displayName][calendarDate] : null;
}
